<template>
  <div>
    <SourcesList class="mb-4"/>
  </div>
</template>

<script>
import SourcesList from './scenarios/Sources-list.vue'

export default {
  components: {
    SourcesList,
  },
}
</script>

<style lang="scss">
</style>
